import React from 'react';

const CheckIcon = (props: any) => {
  return (
    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.12148 8.16149L2.04001 4.08147L0 6.12148L6.12148 12.243L16.3215 2.04145L14.283 0L6.12148 8.16149Z" fill={props.fill ? props.fill : "#365DE6"}/>
    </svg>
  )
}

export default CheckIcon;
